import uuid4 from 'uuid4'

export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const TEMP_ID_PREFIX = 'tmp'

export const generateId = (prefix?: string) => {
  return prefix ? `${prefix}-${uuid4()}` : uuid4()
}
